import React, { Component, PureComponent, PropTypes } from 'react';
import { get, has, debounce } from 'lodash';
import * as ActionTypes from '../../../../../constants/ActionTypes';
import { connect } from 'react-redux';
import './LabelsGridCell.scss';

class LabelsGridCell extends PureComponent {
    static propTypes = {
        languageCode: PropTypes.string.isRequired,
        labelKey: PropTypes.string.isRequired,
        hasAccess: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.restoreValue = this.restoreValue.bind(this);
        this.hideLabel = this.hideLabel.bind(this);
        this.undoChanges = this.undoChanges.bind(this);
        this.changeLabel = this.changeLabel.bind(this);
        this._updateLabelDebounced = debounce(this.props.updateLabel, 200);
        this.state = {
            value: LabelsGridCell._getCurrentValue(props, props.languageCode, props.labelKey),
            isHidden: LabelsGridCell._getCurrentValue(props, props.languageCode, props.labelKey) === ' ' ? true : false
        };
    }

    /**
     * Restores to original value
     */
    undoChanges() {
        const { languageCode, labelKey, originalValue } = this.props;
        const value = get(originalValue, [languageCode, labelKey]);
        if (value !== undefined) {
            this.props.updateLabel([languageCode, labelKey], value);
        } else {
            this.restoreValue();
        }
    }

    /**
     * Restores to higher order value by removing from current edit set
     */
    restoreValue() {
        const { languageCode, labelKey } = this.props;
        this.props.deleteLabel([languageCode, labelKey]);
    }

    hideLabel() {
        const isHiddenValue = this.state.isHidden;
        this.setState(
            {
                isHidden: !isHiddenValue
            },
            () => {
                if (isHiddenValue) {
                    this.restoreValue();
                } else {
                    const { languageCode, labelKey } = this.props;
                    this.props.updateLabel([languageCode, labelKey], ' ');
                }
            }
        );
    }

    changeLabel(e) {
        const { languageCode, labelKey } = this.props;
        const value = e.target.value;
        this.setState({ value }, () => {
            this._updateLabelDebounced([languageCode, labelKey], value);
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: LabelsGridCell._getCurrentValue(nextProps, nextProps.languageCode, nextProps.labelKey),
            isHidden:
                LabelsGridCell._getCurrentValue(nextProps, nextProps.languageCode, nextProps.labelKey) === ' '
                    ? true
                    : false
        });
    }

    static _getCurrentValue(props, languageCode, labelKey) {
        const highOrderValue = get(props.higherOrderLabels, [props.languageCode, labelKey]);
        return get(props.currentValue, [props.languageCode, props.labelKey], highOrderValue);
    }

    render() {
        const isModified = has(this.props.currentValue, [this.props.languageCode, this.props.labelKey]);
        return (
            <td
                className={`lables-grid__cell spark-table-expand ${isModified && 'labels-grid__cell--modified'}`}
                key={this.props.key}
            >
                <textarea
                    wrap="soft"
                    rows="3"
                    className={'labels-grid__input'}
                    value={this.state.value}
                    onChange={this.changeLabel}
                    key={`${this.props.languageCode}.${this.props.labelKey}`}
                />
                <div style={{ marginTop: '1em' }}>
                    <button
                        disabled={!this.props.hasAccess.edit}
                        className={`${
                            this.state.isHidden ? 'spark-icon-password-view' : 'spark-icon-password-hide'
                        } spark-icon spark-btn--icon spark-icon--xs`}
                        onClick={this.hideLabel}
                    />
                    <button
                        disabled={!this.props.hasAccess.edit}
                        className={`spark-icon-arrow-curve-left spark-icon spark-btn--icon spark-icon--xs`}
                        onClick={this.undoChanges}
                    />
                    <button
                        disabled={!isModified || !this.props.hasAccess.edit}
                        className={`spark-icon-close spark-icon spark-btn--icon spark-icon--xs`}
                        onClick={this.restoreValue}
                    />
                </div>
            </td>
        );
    }
}
const mapStateToProps = state => ({
    level: state.app.selected.level,
    chainId: state.app.selected.chain.Id,
    hotelId: state.app.selected.selectedHotel.id,
    higherOrderLabels: state.app.search.labels.higherOrder,
    originalValue: state.app.search.labels.originalValue,
    currentValue: state.app.search.labels.currentValue
});

const mapDispatchToProps = dispatch => ({
    setHigherOrderLabels: labels => dispatch({ type: ActionTypes.SET_HIGHERORDER_LABELS_BATCH, value: labels }),
    setOriginalLables: labels => dispatch({ type: ActionTypes.SET_ORIGINALVALUES_LABELS_BATCH, value: labels }),
    updateLabel: (key, value) => dispatch({ type: ActionTypes.UPDATE_CURRENTVALUE_LABELS_BATCH, key, value }),
    deleteLabel: key => dispatch({ type: ActionTypes.DELETE_LABELS_BATCH, key })
});

export default connect(mapStateToProps, mapDispatchToProps)(LabelsGridCell);



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/labelsGrid/LabelsGridCell.js